import { Box, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import RenderInputField from "../CommonComponents/RenderInputFiled/RenderInputFiled";
import { FRANCHISE_MAPPING_FIELDS } from "../data";

function MapFranchise() {
	const [franchiseData, setFranchiseData] = useState({});

	const handleCreateClick = (e, type) => {};

	return (
		<Stack spacing={2} component="form" onSubmit={(e) => handleCreateClick(e, "create")}>
			<Typography variant="h6">MAP FRANCHISE</Typography>
			{/* form */}
			<Box display="flex" width="690px" columnGap={2} alignItems="center">
				{FRANCHISE_MAPPING_FIELDS.map((row) => (
					<RenderInputField
						column={row}
						data={franchiseData}
						setData={setFranchiseData}
						width="34%"
						selectOptObjName={"option_data"}
					/>
				))}
			</Box>
		</Stack>
	);
}

export default MapFranchise;
